import React from 'react';
import { GiftIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { bonuses, CTA_LABEL } from '../data/content';
export function BonusSection() {
  return <section className="w-full bg-canvas px-4 py-9 sm:px-6 sm:py-12" data-id="element-16" data-mp="22fn0l9256s7x">
      <div className="mx-auto max-w-4xl" data-id="element-17" data-mp="22divwowf5p6l">
        <div className="mx-auto max-w-xl text-center" data-id="element-18" data-mp="1ydi7qcjipzmc">
          <span className="inline-flex items-center gap-1.5 rounded-full bg-accent/10 px-3 py-1 font-display text-[0.6rem] font-extrabold uppercase tracking-wider text-accent-dark sm:text-[0.7rem]" data-id="element-19" data-mp="1ybxbmihk28md">
            <GiftIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-20" data-mp="15n9la8hy8t1y" />
            Incluido hoy
          </span>
          <h2 className="mt-2 font-display text-[1.2rem] font-extrabold uppercase leading-tight text-brand-deep sm:text-3xl" data-id="element-21" data-mp="1jilqxaxn83xn">
            Y para hacerlo aún más fácil, hoy también recibes{' '}
            <span className="text-brand" data-id="element-22" data-mp="qydeeermpm2x">5 recursos extra.</span>
          </h2>
        </div>

        <ul className="mt-5 grid grid-cols-2 gap-2 sm:gap-3" data-id="element-23" data-mp="mws6z8xv6004">
          {bonuses.map((bonus, i) => <li key={bonus.numero} className={`flex h-full gap-2.5 rounded-xl border border-brand/10 bg-white p-3 text-left ${i === bonuses.length - 1 ? 'col-span-2 sm:col-span-1' : ''}`} data-id="element-24" data-mp="29q0cuvn85y6z" data-mpi={i}>
              <span className="mt-px flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-accent/10 font-display text-[0.65rem] font-black text-accent-dark" data-id="element-25" data-mp="2ofxxx2puy7ry">
                {bonus.numero}
              </span>
              <div className="min-w-0" data-id="element-26" data-mp="1vsk7lngo0agt">
                <h3 className="font-display text-[0.82rem] font-extrabold uppercase leading-tight text-brand-deep sm:text-[0.95rem]" data-id="element-27" data-mp="20roci1wk3m1c">
                  {bonus.titulo}
                </h3>
                <p className="mt-0.5 text-[0.75rem] leading-snug text-gray-600 sm:text-[0.85rem]" data-id="element-28" data-mp="3c6k22iwqr7wo">
                  {bonus.frase}
                </p>
              </div>
            </li>)}
        </ul>

        <p className="mt-4 text-center font-display text-[0.8rem] font-extrabold uppercase tracking-wide text-brand sm:text-sm" data-id="element-29" data-mp="1h35a3uzy8pws">
          Los 5 bonus están incluidos sin costo extra.
        </p>

        <div className="mx-auto mt-4 max-w-md" data-id="element-30" data-mp="1q3tmkl9p2i7k">
          <CtaButton href="#precio" location="bonus" data-id="element-31" data-mp="1q3jy524asj3z">
            {CTA_LABEL}
          </CtaButton>
        </div>
      </div>
    </section>;
}